module.exports = __webpack_public_path__ + "static/media/JetBrains.e9e8d21e.svg";